import { useQuery } from "@tanstack/react-query";
import apiDal from "../config/apiDal";
import { DimensionsAndOptions } from "../types";

type GetCategoriesParams = {
	locale?: string;
	categoryId: any;
};

const fetchCategoryDimensionsByCategoryFk = async (
	locale: string = "en-us",
	categoryId?: number,
): Promise<DimensionsAndOptions[]> => {
	const response = await apiDal.post("/queries/fetch", {
		query: "getDimensionOptionsByCategoryFk",
		bind: {
			locale: locale.toLowerCase(),
			categoryId: categoryId,
		},
	});

	return response.data.result;
};

export const useGetCategoryDimensionsByCategoryId = ({ locale, categoryId }: GetCategoriesParams) => {
	return useQuery<DimensionsAndOptions[]>({
		queryKey: ["getDimensionOptionsByCategoryFk", categoryId, locale],
		queryFn: () => fetchCategoryDimensionsByCategoryFk(locale, categoryId ?? undefined),
		select: (data) => {
			return data;
		},
		enabled: !!categoryId,
	});
};
